<template>
    <div id="catalog_container" class="gs:grid">  
        <!-- <div class="backdrop"></div> -->
        <div class="w-full mt-8 md:mt-2">
            <h1 class="tx-44 md:tx-44 mb-2 text-center pt-10 tx-white catalog-title">
               Taller de servicio
            </h1>
            <div id="catalog_content">
                <div id="catalog_state_filter_group">
                    <fieldset id="catalog_state_filter">
                        <legend>Estado</legend>
                        <select class="form-input" v-model="selectedState">
                            <option value="">Todos los estados</option>
                            <option v-for="(state) in getStates" :key="state.id" :value="state.id">{{state.name}}</option>
                        </select>
                    </fieldset>
                </div>
                <div v-for="(item, $index) in this.bodies" :key="$index">
                    <car-service-card-component :data="item" />
                </div>
            </div>
            <infinite-loading spinner="waveDots" :identifier="infiniteId" @infinite="infiniteHandler" ref="infiniteLoading">
                <div slot="no-more"><span style="visibility: hidden;"></span></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </div>
    </div>
  </template>
  <script>
import CarServiceCardComponent from './CarServiceCardComponent.vue';
import metadataService from '../../../../services/metadataService';

  
  export default {
    props: {
        states: String
    },
  
    data: () => ({
        selectedState: '',
        bodies: [],
        total: 0,
        page: 1,
        searchParams: new URLSearchParams('?page=1'),
        infiniteId: +new Date(),
    }),
  
    components: {
        'car-service-card-component': CarServiceCardComponent
    },
  
    beforeMount() {
        this.states
        this.searchParams.delete('state_id')
        this.searchParams.set('page', this.page)
    },
    computed: {
        getStates() {
            return JSON.parse(this.states)
        }
    },
    methods: {
        infiniteHandler($state) {
            axios.get('/api/car-service-affiliates', {
                params: this.searchParams
            }).then(({ data }) => {
                if (data.data.length) {
                    this.searchParams.set('page', parseInt(this.searchParams.get('page'), 10) + 1);
                    this.total = data.meta.total
                    this.bodies.push(...data.data)
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        },
    },
    created() {
        metadataService.createMetaDescription('Taller de Servicio | AutoDeal',
         'Encuentra los mejores talleres para realizar el servicio de tu auto');
    },
    watch: {
        selectedState(value) {
            this.searchParams.set('page', 1)
            this.searchParams.set('state_id', value)
            this.bodies = []
            this.infiniteId += 1
        }
    }
  }
  </script>
  <style lang="css">
  
    @media (min-width: 1280px) {
        .main__wrapper {
            min-width: 100vw;
        }
    }
  
    @media (min-width: 768px) {
        .main__wrapper {
            min-width: 100vw;
        }
        .mt-2 {
            margin-top: 0;
        }
    }
  
    @media (max-width: 542px) {
        .header__search__filters {
            width: 80%;
            right: none;
        }
        .header__filters {
            width: 20%;
            position: absolute;
            right: 0;
            top: 46px;
            background: #000000;
            padding: 8px 0 10px 12px;
            border-bottom: 1px solid #000000;
  
        }
        .mr-1 {
            margin-right: 0;
        }
    }
  </style>
  
  <style scoped>
  .catalog-title {
    position: relative;
    text-transform: uppercase;
    font-size: calc(62.5% * 4);
    text-shadow: 0 0 50px #000000cb, 0 0 80px #000000b8, 0 0 100px #000000bf;
  }

  #catalog_container {
    position: relative;
    min-height: 100vh;
  }
  #catalog_container::before {
    z-index: -1;
    content: "";
    position: absolute;
    top: 0; 
    left: 0;
    width: 100%; 
    height: 100%;
    background: url(../../../../../images/taller.jpg), #c9c8c438;
    background-position: 28% top;
    margin-top: -6px;
    background-size: contain;
    background-repeat: no-repeat;
  }

#catalog_content {
    scrollbar-gutter: stable;
    padding: 26px 0;
    overflow-y: auto;
    position: relative;
    display: grid;
    justify-content: center;
    gap: 20px;
    grid-template-columns: repeat(auto-fill, 250px);
  }

#catalog_state_filter_group {
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    border-radius: 5px;
    background-color: #fff;
    max-width: 100%;
    z-index: 2;
    grid-row: 1 / 2;
    grid-column: 1 / -1;
}

#catalog_state_filter {
    position: relative;
    z-index: 2;
    color: #818181;
    border: none;
}

  @media screen and (min-width: 1024px) {
    #catalog_state_filter_group {
        /* margin: 10px 8%; */
        max-width: 250px;
    }
    #catalog_container::before {
        background-size: cover;
        background-repeat: no-repeat;
    }
    #catalog_content {
        flex-direction: row;
        align-content: start;
        padding-top: 20px;
    }
  }

  .hot-deal-2{
    text-align: center;
    color: white;
    background-color: black;
    padding: 4px;
    border-radius: 5px;
  }
  .img-bd{
    max-width: 100px;
  }
  </style>
  